export const getLeftRoundedRectPath = (
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
) => `
  M ${x + radius},${y}
  H ${x + width}
  V ${y + height}
  H ${x + radius}
  A ${radius},${radius} 0 0 1 ${x},${y + height - radius}
  V ${y + radius}
  A ${radius},${radius} 0 0 1 ${x + radius},${y}
  Z
`;

export const getRightRoundedRectPath = (
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
) => `
  M ${x},${y}
  H ${x + width - radius}
  A ${radius},${radius} 0 0 1 ${x + width},${y + radius}
  V ${y + height - radius}
  A ${radius},${radius} 0 0 1 ${x + width - radius},${y + height}
  H ${x}
  Z
`;
